// [NOTE] Ensure that you add ROOT_URL to your .env file
const ROOT_URL = process.env.REACT_APP_API_URL;
// const ROOT_URL = "http://localhost:8000/api/"

// User authentication
export const signupUrl = () => `${ROOT_URL}user/signup/`;
export const loginUrl = () => `${ROOT_URL}user/login/`;
export const forgotPasswordUrl = () => `${ROOT_URL}user/password-reset/`;
export const setNewPasswordUrl = () => `${ROOT_URL}user/password-reset-confirm/`;

export const addSpotUrl = () => `${ROOT_URL}spot/`;
export const getOwnerSpotsUrl = (ownerId, spotId, search) => {
  const baseUrl = `${ROOT_URL}spot/staff?owner=${ownerId}`;
  let url = spotId ? `${baseUrl}&spot=${spotId}` : baseUrl;
  url = search ? `${url}&search=${search}` : url;
  return url;
};
export const updateSpotUrl = spotId => `${ROOT_URL}spot/?id=${spotId}`;
export const getSpotStaffUrl = (spotId, params) =>
  params ? `${ROOT_URL}spot/${spotId}/staff?${new URLSearchParams(params).toString()}` : `${ROOT_URL}spot/${spotId}/staff`;

export const getMenuUrl = (params) =>
  params ? `${ROOT_URL}spot/menuitem?${new URLSearchParams(params).toString()}` : `${ROOT_URL}spot/menuitem`;

export const getBankListUrl = () => `${ROOT_URL}payment/banks`;
export const withdrawFundsUrl = (amount, spot) => `${ROOT_URL}payment/wallet-withdrawal?spot=${spot}&amount=${amount}`;
export const confirmWithdrawalUrl = () => `${ROOT_URL}payment/wallet-withdrawal`;
export const getTransactionUrl = (params) =>
  params ? `${ROOT_URL}payment/transaction?${new URLSearchParams(params).toString()}` : `${ROOT_URL}payment/transaction`;
export const getBankAccountNameUrl = params => `${ROOT_URL}payment/wallet-withdrawal?${new URLSearchParams(params).toString()}`;

export const raverOrderUrl = (params) =>
  params ? `${ROOT_URL}spot/guest/order?${new URLSearchParams(params).toString()}` : `${ROOT_URL}spot/guest/order`;
export const raverTabUrl = (params) =>
  params ? `${ROOT_URL}spot/guest/tab?${new URLSearchParams(params).toString()}` : `${ROOT_URL}spot/guest/tab`;

export const getCategoriesUrl = (spotId = null) =>
  spotId ? `${ROOT_URL}spot/categories/?spot=${spotId}` : `${ROOT_URL}spot/categories/`;
export const getTabHistoryUrl = (params) =>
  params ? `${ROOT_URL}spot/tabs/history?${new URLSearchParams(params).toString()}` : `${ROOT_URL}tabs/history`;
